import { FC } from 'react';

import { TIconType } from 'shared/presentation/constants';

import * as S from './styles';

interface IAlertInformationCard {
  icon: TIconType;
  title: string;
  message?: string;
  variant?: S.TVariant;
}

const AlertInformationCard: FC<IAlertInformationCard> = ({
  icon: Icon,
  title,
  message,
  variant = 'purple',
}) => (
  <S.Container variant={variant}>
    <Icon />

    <div className="information">
      <h3 className="information__title">{title}</h3>

      {message && <p className="information__message">{message}</p>}
    </div>
  </S.Container>
);

export default AlertInformationCard;
